import { render, staticRenderFns } from "./fullnotices.vue?vue&type=template&id=e6b4b0f2&scoped=true&"
import script from "./fullnotices.vue?vue&type=script&lang=js&"
export * from "./fullnotices.vue?vue&type=script&lang=js&"
import style0 from "./fullnotices.vue?vue&type=style&index=0&id=e6b4b0f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b4b0f2",
  null
  
)

export default component.exports